import { Model as t } from "../../../../model.js";
class h extends t {
  constructor(r) {
    super(), this.background = r.background, this.text = r.text, this.lines = r.lines, this.highlightBackground = r.highlightBackground, this.highlightText = r.highlightText, this.highlightLines = r.highlightLines, this.primaryButtonBackground = r.primaryButtonBackground, this.primaryButtonText = r.primaryButtonText, this.secondaryButtonBackground = r.secondaryButtonBackground, this.secondaryButtonText = r.secondaryButtonText, this.errorBackground = r.errorBackground, this.errorText = r.errorText;
  }
}
export {
  h as CheckoutDesignColorsModel
};
//# sourceMappingURL=colors.model.js.map
